import './styles/primereactstyles.css'
import ReactDOM from 'react-dom/client'

declare global {
  interface Window {
    overrideUserProps?: (props: object) => void
  }
}

import { I18nextProvider } from 'react-i18next'
import { Provider as ReduxProvider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './components/App'
import i18next from './i18n/i18next'
import './index.scss'
import { AuthProvider } from './auth/authProvider'
import { store } from './redux/store'
import { isDemo, isProduction } from './types/constants'

if ((isProduction || isDemo) && !('enableLog' in window)) {
  console.log = () => undefined
}

if (!isProduction) {
  window.overrideUserProps = (props: object) => store.dispatch({ type: 'SET_USER_PROPS', props })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ReduxProvider store={store}>
    <I18nextProvider i18n={i18next}>
      <Router>
        <AuthProvider>
          <App />
        </AuthProvider>
      </Router>
    </I18nextProvider>
  </ReduxProvider>
)
